import { gql } from 'graphql.macro';

export const dataSetSwitchStatusTemplate = gql`
    query dataSetSwitchStatus {
        dataSetSwitchStatus {
            state
            dataSet
            step
            copiedDocuments
            totalDocuments
            copiedCollections
            totalCollections
            currentCollection
            startedAt
            finishedAt
            startedBy
            error
        }
    }
`;

export const dataSetsTemplate = gql`
    query dataSets {
        dataSets {
            dataSet
            available
            snapshotDate
        }
    }
`;
